<template>
<div>
  <div class="grid-container">
    <div class="accordion disp-scroll">
      <ul>
        <template v-if="reReleaseTexts.length > 0">
          <li v-for="(c, index) in reReleaseTexts"
              :key = index  class="menu-card-small"
              v-bind:class="{'menu-card-hover' : nowID == c.contents_id}"
              @click="releaseGet(index)">
            <div class="contentsTitle">
                {{c.title}}
            </div>
            <div class="contents-time">
                {{getTimes(c.updated_at)}} 
            </div>
            <div class="new-message" v-if='c.is_read'> 
              <p>New!</p>
            </div>
          </li>
        </template>
        <template v-else>
          <li>
            <div class="contentsTitle">
            </div>
            <div class="contents-time" style="color: #2c3e50; text-align: center;">
              現在情報はございません
            </div>
          </li>
        </template>
      </ul>
    </div>
    <div class="markdown">
      <div style="margin:10px 25px 0 0; text-align:right; ">
        {{nowDate}}
      </div>
      <div class="disp-scroll" style="border: solid thin #ccc; padding: 8px; height: 550px; text-align:left;">
        <mavon-editor
          language="ja"
          style="height:530px;width:100%;"
          v-model="value"
          :subfield="false"
          defaultOpen="preview"
          :toolbarsFlag="false"
          :scrollStyle="true"
          :boxShadow="false" />
        </p>
      </div>
      <button class="close-button" @click="isClose()">閉じる</button>
    </div>
  </div>
</div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import mavonEditor from "mavon-editor";
import "mavon-editor/dist/css/index.css";
Vue.use(mavonEditor);

export default {
  props: {
    sendnowID: String,
    sendvalue: String,
    sendnowDate: String,
    sendreadDate: Number,
    sendtitle: String,
  },
  data() {
    return {
      nowID: this.sendnowID,
      nowDate: this.sendnowDate,
      readDate: this.sendreadDate,
      value: this.sendvalue,
      title: this.sendtitle,
      storageData: {},
      localData: []
    }; 
  },
  computed:{
    ...mapState('auth', ['user']),
    ...mapState("tools",["releaseContents", "draftTexts", "releaseTexts"]),
    reReleaseTexts(){
      return this.releaseTexts.sort((a, b) => {
        return (this.getSort(a.updated_at) < this.getSort(b.updated_at))? 1 : (this.getSort(a.updated_at) > this.getSort(b.updated_at)) ? -1 : 0;
      })
    },
  },
  watch:{
    releaseTexts () {
      var readUpdate = true
      this.localData = []
      setTimeout(() => {
        for(var i = 0; i < Object.keys(this.storageData).length; i++)
          if(this.storageData[i] == this.nowID + "/" + this.readDate){
            readUpdate = false
          }
        if(readUpdate == true){
          this.storageData[Object.keys(this.storageData).length] = this.nowID + "/" + this.readDate
        }
        localStorage.setItem('IS_RELEASE_READ', JSON.stringify(this.storageData))
        for(var i = 0; i < Object.keys(this.storageData).length; i++)
          this.localData.push(this.storageData[i])
      },500)
    }
  },
  mounted() {
    this.localData = []
    this.storageData = JSON.parse(localStorage.getItem('IS_RELEASE_READ') || null)
    if (this.storageData == null) {
      this.storageData = {}
    }
    for (var i = 0; i < Object.keys(this.storageData).length; i++)
      this.localData.push(this.storageData[i])
      setTimeout(() => {
        this.nowID = this.sendnowID
        this.nowDate = this.sendnowDate
        this.readDate = this.sendreadDate
        this.value=  this.sendvalue
        this.title = this.sendtitle
      }, 500)
    this.readNotification(this.nowID)
  },
  methods: {
    isClose() {
      this.$parent.close()  
      this.$store.dispatch("tools/getText")
      this.$emit('contentsMessage', 1)
    },
    lastRead() {
      var readID = localStorage.getItem('IS_RELEASE_READ')
      return readID
    },
    releaseGet (index) {
      this.value = this.releaseTexts[index].contents
      this.nowDate = this.getTimes(this.releaseTexts[index].updated_at)
      this.readDate = this.getSort(this.releaseTexts[index].updated_at)
      this.nowID = this.releaseTexts[index].contents_id
      this.nowContents = this.releaseTexts[index].contents
      this.title = this.releaseTexts[index].title
      this.localData = []
      this.readNotification(this.releaseTexts[index].contents_id)
    },
    readNotification (contentsId) {
      const data = {contents_id: contentsId}
      if (contentsId !== '') {
        this.$store.dispatch('tools/readNotification', data)
          .then(() => {
            this.$store.dispatch('tools/getText')
          })

      }

    },
    getMessage(id, date) {
      var message = id + "/" + this.getSort(date)
      return message
    },
    getTimes(time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time.replace(/Jan/g, '01').replace(/Feb/g, '02').replace(/Mar/g, '03').replace(/Apr/g, '04').replace(/May/g, '05').replace(/Jun/g, '06').replace(/Jul/g, '07').replace(/Aug/g, '08').replace(/Sep/g, '09').replace(/Oct/g, '10').replace(/Nov/g, '11').replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_time = new_time.substring(15,20)
      var dis_time = get_year + '-' + get_month + '-' + get_day + ' ' + get_time
      return dis_time
    },
    getSort(time) {
      var ja_time = new Date(time.replace(/-/g, '/').substring(0, 17) + time.substring(25, 29)).toString()
      var new_time = ja_time.replace(/Jan/g, '01').replace(/Feb/g, '02').replace(/Mar/g, '03').replace(/Apr/g, '04').replace(/May/g, '05').replace(/Jun/g, '06').replace(/Jul/g, '07').replace(/Aug/g, '08').replace(/Sep/g, '09').replace(/Oct/g, '10').replace(/Nov/g, '11').replace(/Dec/g, '12')
      var get_year = new_time.substring(10,14)
      var get_month = new_time.substring(4,6)
      var get_day = new_time.substring(7,9)
      var get_hour = new_time.substring(15,17)
      var get_minute = new_time.substring(18,20)
      var dis_time = get_year + get_month + get_day + get_hour + get_minute
      return Number(dis_time)
    }
  }  
}
</script>

<style lang="scss" scoped>
.grid-container {
  display: grid;
  grid-template-columns: 200px 750px;
  grid-template-rows: 650px;
  grid-template-areas: "accordion markdown";
}
.accordion {
  grid-area: accordion;
  background: white;
}
.accordion::-webkit-scrollbar-thumb {
  background: #E53787;
}
.accordion::-webkit-scrollbar-track-piece:start {
  border-radius: 10px;
  background: silver;
}
.accordion::-webkit-scrollbar-track-piece:end {
  border-radius: 10px;
  background: silver;
}
.markdown {
  grid-area: markdown;
  background-color: white;
  color:black
}
.menu-card-small {
  text-align: left;
  padding-left:10px;
  padding-top:5px;
  color:black;
  background-color: white;
  margin-top:5px;
  margin-bottom:5px;
  margin-left:10px;
  height: 70px;
  width: 170px;
  border: solid thin #222;
  position:relative;
}
.menu-card-small:hover {
  background-color: rgb(240, 167, 184);
  color: white;
}
.menu-card-small a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-small a:link {
  color: black;
}
.menu-card-small a:visited {
  color: black;
}
.menu-card-small a:hover {
  color: black;
}
.menu-card-small a:active {
  color: black;
}
.menu-card-hover{
  background-color: #E53860;
  color: white;
  position:relative;
}
.menu-card-hover:hover{
  background-color: #E53860;
  color: white;
  cursor:auto;
}
.menu-card-hover a {
  text-decoration: none;
  display: block;
  width: 100%;
  height: 100%;
}
.menu-card-hover a:link {
  color: white;
}
.menu-card-hover a:visited {
  color: white;
}
.menu-card-hover a:hover {
  color: white;
}
.menu-card-hover a:active {
  color: white;
}
ul {
  list-style: none;
}
.card-header-title{
  padding-left:20%;
  font-size:20px;
}
.close-button{
  margin-left:640px;
  margin-top:5px;
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  text-decoration: none;
  color: rgb(75, 70, 70);
  background: #ECECEC;
  border-radius:5px;
}
.contentsTitle{
  font-size:100%;
}
.contents-time{
  font-size:90%;
  text-align:end;
  padding-right:5px;
  padding-top:15px;
}
.new-message{
  font-size: 12px;
  position: absolute;
  color:silver;
  bottom:10px;
  left:2.5px;
  bottom:5px;
  padding: 1px 3px;
  color: #ffffff;
  background: rgb(0, 0, 0);
  border: 4px solid #000000;
  border-radius: 8px;
  animation: flash 1.5s linear infinite;
}
@keyframes flash {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Release/ViewMarkdown.vue